import 'moment/min/locales';

import { Button, Col, Row } from 'design-react-kit/dist/design-react-kit';
import { ListingLinkMore, SimpleCard } from '@arpav/components/ArpavTheme';
import React, { useState } from 'react';

import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment';
import { useIntl } from 'react-intl';

const SimpleCardTemplateDefault = ({
  items,
  isEditMode,
  linkTitle,
  linkHref,
  show_icon = true,
  show_section = true,
  show_type,
  show_description = true,
  show_detail_link,
  detail_link_label,
  title,
  description,
  show_block_bg,
  hide_dates,
  path_filters,
  show_path_filters,
  addFilters,
  additionalFilters = [],
}) => {
  const intl = useIntl();
  moment.locale(intl.locale);

  let currentPathFilter = additionalFilters
    ?.filter(f => {
      return f.i === 'path';
    })
    ?.map(f => {
      return f.v;
    });

  const [pathFilter, setPathFilter] = useState(currentPathFilter?.[0] || null);

  const path_filters_buttons =
    show_path_filters && path_filters
      ? Object.keys(path_filters)
          .map(k => {
            return {
              label: path_filters[k].label,
              path: path_filters[k].path?.[0],
            };
          })
          .filter(f => f.path)
      : null;

  const addPathFilter = path => {
    let new_path = pathFilter === path ? null : path;
    setPathFilter(new_path);
    let filters = [];
    if (new_path) {
      filters = [
        {
          i: 'path',
          o: 'plone.app.querystring.operation.string.absolutePath',
          v: new_path,
        },
      ];
    }
    addFilters(filters);
  };

  return (
    <div className="simple-card-default">
      {(title || path_filters_buttons) && (
        <Row
          className={cx('template-header', {
            'with-filters': path_filters_buttons,
          })}
        >
          {title && (
            <Col md={path_filters_buttons ? 6 : 12}>
              <h2
                className={cx('', {
                  'mt-5': !show_block_bg,
                  'mb-4': !path_filters_buttons,
                })}
              >
                {title}
              </h2>
              {description ? <p>{description}</p> : null}
            </Col>
          )}

          {path_filters_buttons && (
            <Col md={title ? 6 : 12} className="path-filter-buttons">
              <div className="path-filter-buttons-wrapper">
                {path_filters_buttons.map((button, i) => (
                  <Button
                    key={i}
                    color="primary"
                    outline={button.path['@id'] !== pathFilter}
                    size="xs"
                    icon={false}
                    tag="button"
                    className="ml-3"
                    onClick={() => {
                      addPathFilter(button.path['@id']);
                    }}
                  >
                    {button.label}
                  </Button>
                ))}
              </div>
            </Col>
          )}
        </Row>
      )}

      <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3 mb-3">
        {items.map(item => (
          <SimpleCard
            key={item['@id']}
            content={item}
            isEditMode={isEditMode}
            show_icon={show_icon}
            show_section={show_section}
            show_type={show_type}
            show_description={show_description}
            show_detail_link={show_detail_link}
            detail_link_label={detail_link_label}
            hide_dates={hide_dates}
          />
        ))}
      </div>

      <ListingLinkMore title={linkTitle} href={linkHref} className="my-4" />
    </div>
  );
};

SimpleCardTemplateDefault.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
};

export default SimpleCardTemplateDefault;
